import { axios } from '@/utils/request'

export function getPaperPeriodList() {
    return axios.get('/paper_periods')
}

export function getPaperPeriodDetail(paperPeriodId) {
    return axios.get(`/paper_periods/${paperPeriodId}`)
}

export function getUserPaperToken(paperPeriodId) {
    return axios.get(`/paper_periods/${paperPeriodId}/submission_token`)
}

export function storeUserPaper(paperPeriodId, data) {
    return axios.post(`/paper_periods/${paperPeriodId}/user_paper`, data)
}

export function getUserPaperDetail(userPaperId) {
    return axios.get(`/paper_periods/user_paper/${userPaperId}`)
}

export function getUserPaperList() {
    return axios.get(`/paper_periods/user_papers`)
}